import React from 'react';
import TextEditor from '../shared/TextEditor';

const MessageInput = ({ newMessage, onMessageChange, onSendMessage, error }) => {
  return (
    <footer className="footer pb-2">
      <form onSubmit={onSendMessage}>
        <div className="px-3">
          <div>
            {error && <span className="invalid-feedback d-block">{error}</span>}
            <TextEditor
              isMenushow={true}
              className="rounded-2 input-editor-expand-height"
              value={newMessage}
              handleChange={onMessageChange}
            />
            <div className="text-editor-action d-flex justify-content-end align-items-center pt-2">
              <button
                type="submit"
                className="btn bg-blue btn-sm me-2 text-white fw-600"
                title="Send Message">
                Send
              </button>
            </div>
          </div>
        </div>
      </form>
    </footer>
  );
};

export default MessageInput;
